module.exports = __webpack_public_path__ + "static/media/Ghana.d4a4f090.png";